// "Erkannten Rohtext anzeigen" (Bauplan Punkt 8): collapsible <pre> mit dem von der OCR erkannten
// Volltext (doc.rawText, bereits heute von store.getDocument geliefert). Hilft bei no_ruleset/
// failed/ignored-Dokumenten zu pruefen, ob ueberhaupt Text erkannt wurde.

import React from 'react';
import { FileText, ChevronDown } from 'lucide-react';
import { Card } from '../ui';

const AbRawTextPanel = ({ isDarkMode, t, rawText }) => {
  if (!rawText) return null;
  return (
    <Card isDarkMode={isDarkMode} className="!p-0 overflow-hidden">
      <details>
        <summary className={`list-none flex items-center justify-between gap-2 px-5 py-4 cursor-pointer select-none ${isDarkMode ? 'hover:bg-white/[0.03]' : 'hover:bg-slate-50'}`}>
          <span className={`flex items-center gap-2 text-sm font-semibold ${isDarkMode ? 'text-white/85' : 'text-slate-700'}`}>
            <FileText className="w-4 h-4" />{t('abPdf.rawTextTitle')}
          </span>
          <ChevronDown className={`w-4 h-4 ${isDarkMode ? 'text-white/40' : 'text-slate-400'}`} />
        </summary>
        <pre className={`mx-5 mb-5 text-xs whitespace-pre-wrap font-mono rounded-xl p-3 max-h-96 overflow-auto ${isDarkMode ? 'bg-black/30 text-white/60' : 'bg-slate-50 text-slate-600'}`}>
          {rawText}
        </pre>
      </details>
    </Card>
  );
};

export default AbRawTextPanel;
